export default __webpack_public_path__ + "static/media/AllProductItems2.2e1997f3.png";